<template>
  <section class="content">
    <!-- <keep-alive> -->
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <div v-if="show" class=" _message" :class="messageType">
          <strong>{{ this.message }}</strong>
        </div>
        <form class="form-horizontal">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button @click.prevent="searchInvoice"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
              <!-- <button type="submit" style="margin-left:10px;margin-top: 24px;"  @click.prevent="reset"
             class="btn btn-info pull-left">Reset</button> -->
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" @click.prevent="exportCSV()">
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
            </a>
            <DataTable :value="salesInvoiceLists"
                       :paginator="true"
                       :rowsPerPageOptions="[100,500,1000]"
                       :rows="100" :filters="filters"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id"
                       :selection.sync="selectedProduct1" selectionMode="single">
              <Column header="S.N">
                <template #body="sl">
                  {{ sl.index + 1 }}
                </template>
              </Column>
              <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali"
                      filterField="purchaseSalesDateNepali"
                      filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']" />
                </template>
                      </Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate"
                      filterField="purchaseSalesDate"
                      filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']" />
                </template>
                      </Column>
              <Column header="Bill No" :sortable="true" field="billNo" filterField="billNo" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['billNo']" />
                </template>
                </Column>
              <Column header="Customer" :sortable="true" field="accountName" filterField="accountName"
                      filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
                </template>
                <template #footer>
                  Total:
                </template>
                </Column>
              <Column header="Address" :sortable="true" field="address" filterField="address"
                      filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']" />
                </template>
                </Column>
              <Column header="Sub Total" bodyStyle="text-align: right" field="subTotalAmount"
                      filterField="subTotalAmount"
                      filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['subTotalAmount']" />
                </template>
                <template #footer>
                  {{ totalSubAmount.toFixed(2) }}
                </template>
                      </Column>
              <Column header="Non-taxable" bodyStyle="text-align: right" field="nonTaxableAmount"
                      filterField="nonTaxableAmount" filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['nonTaxableAmount']" />
                </template>
                <template #footer>
                  {{ totalNonTaxableAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Taxable" bodyStyle="text-align: right" field="taxableAmount" filterField="taxableAmount"
                      filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['taxableAmount']" />
                </template>
                <template #footer>
                  {{ totalTaxableAmount.toFixed(2) }}
                </template>
                      </Column>
              <Column header="Vat" bodyStyle="text-align: right" field="vatAmount" filterField="vatAmount"
                      filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['vatAmount']" />
                </template>
                <template #footer>
                  {{ totalVatAmount.toFixed(2) }}
                </template>
                      </Column>
              <Column header="Total" bodyStyle="text-align: right" field="totalBillAmount" filterField="totalBillAmount"
                      filterMatchMode="contains">
                      <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']" />
                </template>
                <template #footer>
                  {{ totalSumBillAmount.toFixed(2) }}
                </template>
                      </Column>
              <template #empty>No record found</template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'

export default {
  name: 'salesInvoiceReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      salesInvoiceLists: [],
      loading: false,
      dialogShow: false,
      selectedProduct1: null,
      message: '',
      messageType: '',
      show: false,
      englishDateEnabled: true,
      totalSubAmount: 0,
      totalNonTaxableAmount: 0,
      totalTaxableAmount: 0,
      totalVatAmount: 0,
      totalSumBillAmount: 0,
      filters: {}
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async searchInvoice() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadpurchaseInvoiceLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.salesInvoiceLists = []
      } else {
        this.salesInvoiceLists = resp.data.data
      }
      this.totalBalance()
    },
    totalBalance() {
      this.totalSubAmount = 0.0
      this.totalNonTaxableAmount = 0.0
      this.totalTaxableAmount = 0.0
      this.totalVatAmount = 0.0
      this.totalSumBillAmount = 0.0
      for (let sale of this.salesInvoiceLists) {
        this.totalSubAmount += sale.subTotalAmount
        this.totalNonTaxableAmount += sale.nonTaxableAmount
        this.totalTaxableAmount += sale.taxableAmount
        this.totalVatAmount += sale.vatAmount
        this.totalSumBillAmount += sale.totalBillAmount
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        salesDate: data.purchaseSalesDateNepali,
        billNo: data.billNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        subTotalAmount: data.subTotalAmount,
        nonTaxableAmount: data.nonTaxableAmount,
        taxableAmount: data.taxableAmount,
        vatAmount: data.vatAmount,
        totalBillAmount: data.totalBillAmount,
        vatTypeEnum: data.vatTypeEnum
      }
      this.$router.push({name: 'sales Detail Report', params: {salesHeaderObj: PIHdata}})
    },
    async editSalesInvoice(data) {
      this.$router.push({name: 'Sales Invoice', params: {salesInvoice: data}})
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.show = true
        this.setTimeInterval()
        this.message = 'Delete Reason cannot be empty.'
        this.messageType = 'alert-Danger'
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteSales', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.show = true
        this.setTimeInterval()
        this.message = resp.data.message
        this.messageType = 'alert-Success'
        this.dialogShow = false
      } else {
        this.show = true
        this.setTimeInterval()
        this.message = resp.data.message
        this.messageType = 'alert-Warn'
        this.dialogShow = false
      }
    },
    reset() {
      this.salesInvoiceLists = []
      if (!this.$store.getters.englishDate) {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    cancel(data) {
      this.dialogShow = false
      this.show = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setTimeInterval() {
      setTimeout(() => {
        this.show = false
      }, 3000)
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputMask,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// purchaseTaxRegister.vue?67d031a8